import AboutBanner from './AboutBanner';
export default AboutBanner;
